module.exports = __webpack_public_path__ + "media/images/athletes/2749-cdc5e44767bed4e7141d6311dcb5cf6f.png";